import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

type SortingPropsType = {
  sortFactor: string
  callback: (sortFactor: string, column: string) => void
  column: string
}

export const Sorting =React.memo((props: SortingPropsType) => {
  console.log('SORTING is called')
  switch (props.sortFactor) {
    case '':
      return <ArrowDownwardIcon  onClick={() => props.callback('asc', props.column)} fontSize="small" color="disabled" />;
    case 'asc':
      return <ArrowDownwardIcon onClick={() => props.callback('desc', props.column)} fontSize="small" color='info' />;
    case 'desc':
      return <ArrowUpwardIcon onClick={() => props.callback('', props.column)} fontSize="small" color='info' />;
    default:
      return <ArrowDownwardIcon onClick={() => props.callback('asc', props.column)} fontSize="small" color="disabled" />;
  }
})
